import http from './httpService';
import {encodeQueryData} from '../../Utils/Common';
const API_URL_TARGET = process.env.REACT_APP_API_URL_TARGET;
const API_URL_PTS = process.env.REACT_APP_API_URL_PTS;


async function getCustomerData(params:any) {
    const url = `${API_URL_TARGET}get_customer_data?`+encodeQueryData(params);
    let response = await http.get(url);
    return response;
}

async function getCustomerSummaryData(params:any) {
    const url = `${API_URL_PTS}geptssummarydata?`+encodeQueryData(params);
    let response = await http.get(url);
    return response;
}

const CompanyInformationServices = {
    getCustomerData,
    getCustomerSummaryData,
};

export default CompanyInformationServices;